import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';

@Injectable({
  providedIn: 'root'
})
export class FileCategoryApiService extends ApiService {
  readonly resourcePath = 'file_categories';

  update(id:string,body:any){
    return this.restUpdate(id,body);
  }
  list(filters: Record<string, string> = {}): Observable<HydraCollection<any>> {
    return this.restList<any>(filters);
  }
}
